<template>
    <div class="box">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <center class="heading">
            <h3>
                <strong>
                    Edit Question Bank
                </strong>
            </h3>
        </center>
        <br />
        <span class="slide">*NOTE:Question And Option Image File size Should be less than 200kb And It Should be in JPEG Format!!!</span>
        <v-row class="box card-border">
            <v-tooltip bottom color="rgb(1, 127, 152)">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" class="mx-2 button-cancel" fab small @click="back()"><v-icon>mdi-close</v-icon></v-btn>
                </template>
                <span>
                    close
                </span>
            </v-tooltip>
            <v-col cols="12" sm="5">
                <strong>Course: {{course_code}}:{{course_name}}</strong>
            </v-col>
            <v-col cols="12" sm="3"> </v-col>
            <v-col cols="12" sm="3">
                <strong>Question Type: {{questiontype.name}}</strong>
            </v-col>
        </v-row>
        <v-card class="box" flat>
            <v-col cols="12" sm="12" md="12">
                <v-card class="card-border">
                    <center class="heading">
                        <h4><strong>Question</strong></h4>
                    </center>
                    <!-- <v-alert class="alert" v-if="this.flag==true" dismissible outlined type="error">
                        Image size should be less than 200KB!
                    </v-alert> -->
                    <v-row>
                        <v-row justify="center">
                            <v-col cols="12" sm="4">
                                <v-autocomplete :items="unit_info_list" item-text="name" label="Select Unit" v-model.trim="unit" return-object></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-autocomplete :items="difficulty_info_list" item-text="name" v-model.trim="difficultylevel" label="Select Difficulty Level" return-object></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-col cols="12" sm="9">
                            <ckeditor v-model="question_edit" :config="editorConfig"></ckeditor>
                        </v-col>
                        <!-- <v-col cols="12" sm="1">
                            <v-select :items="marks_list" label="Marks" v-model.trim="weightage_edit" item-value="id" item-text="marks" required></v-select>
                        </v-col> -->
                        
                        <v-col cols="12" sm="2">
                            Approve?::
                            <v-checkbox v-model="isapprove_edit" class="mx-2"></v-checkbox> 
                          
                            <v-file-input v-model="file_edit" accept="image/jpeg, image/jpg" id="file" prepend-icon="mdi-attachment" label="Choose File" show-size name="doc"></v-file-input>
                            <span v-if="que_file != null">
                                <!-- {{que_file_link}} -->
                                Previous File :<img class="imgs" :src="que_file" @click="zooimg(que_file) " />
                            </span>
                            <span v-if="que_file != null">
                                <v-icon color="red" @click="deletedialog(que_id,'question')">mdi-delete-circle</v-icon>
                            </span>
                        </v-col>
                    </v-row>
                </v-card>
                <v-col cols="12" sm="12" md="12" class="p-0">
                    <center class="heading">
                        <h4><strong>Options</strong></h4>
                    </center>
                </v-col>
                <v-alert class="alert" v-if="this.flag1==true" dismissible outlined type="error">
                    Image size should be less than 200KB!
                </v-alert>
                <v-col cols="12" sm="12" md="12" v-for="(opt,index) in my_opt_list" :key="opt.opt_id">
                    <v-card class="card-border">
                        <v-row>
                            <v-col cols="12" sm="2"> Option::{{opt.opt_name}} </v-col>
                            <v-col cols="12" sm="7">
                                <ckeditor v-model="opt.opt_txt" :config="editorConfig"></ckeditor>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-col cols="12" sm="12">
                                    <v-file-input accept="image/jpeg, image/jpg" v-model="opt.filename" id="file" prepend-icon="mdi-attachment" label="Choose File" show-size name="doc" @change="validateFile1()"></v-file-input>
                                    <span v-if="opt.opt_file_path != null">
                                        <span v-if="opt.opt_file_path != null"> Previous File :<img class="imgs" :src="opt.answerfile" @click="zooimg(opt.answerfile) " /> </span>
                                        <span v-if="opt.opt_file_path != null">
                                            <v-icon color="red" @click="deletedialog(opt.opt_id,'option')">mdi-delete-circle</v-icon>
                                        </span>
                                    </span>
                                </v-col>
                                <!-- {{opt.opt_iscorrect}} -->
                                <input type="radio" :value="opt.opt_iscorrect" @change="radio(index)" :checked="opt.opt_iscorrect" />
                                Correct Answer
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                <div id="A" style="display: none;">
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="card-border">
                            <v-alert class="alert" v-if="this.flag2==true" dismissible outlined type="error">
                                Image size should be less than 200KB!
                            </v-alert>
                            <v-row>
                                <v-col cols="12" sm="1" md="1">
                                    <v-tooltip bottom color="primary">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" class="mx-2 button-cancel" fab small @click="close1()"><v-icon dark>mdi-close</v-icon></v-btn>
                                        </template>
                                        <span>
                                            Remove
                                        </span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="12" sm="7" md="8">
                                    <ckeditor v-model="option_01" :config="editorConfig"></ckeditor>
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <v-row>
                                        <v-col cols="12">
                                            <v-file-input v-model="optfile1" accept="image/jpeg, image/jpg" prepend-icon="mdi-attachment" label="Choose File" id="file1" show-size name="doc"></v-file-input>
                                        </v-col>
                                        <v-col cols="12">
                                            <input type="radio" class="radiospace" id="a" value="a" v-model="iscorrect_01" @change="radio1(iscorrect_01)" />
                                            <label for="a">Correct Answer</label>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-btn style="display" class="button btn-submit-align" id="option2" :loading="loader" @click="enableOption2()">Add Option</v-btn>
                </div>
                <div id="B" style="display: none;">
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="card-border">
                            <!-- <v-alert class="alert" v-if="this.flag3==true" dismissible outlined type="error">
                                Image size should be less than 200KB!
                            </v-alert> -->
                            <v-row>
                                <v-col cols="12" sm="1" md="1">
                                    <v-tooltip bottom color="primary">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" class="mx-2 button-cancel" fab small @click="close2()"><v-icon dark>mdi-close</v-icon></v-btn>
                                        </template>
                                        <span>
                                            Remove
                                        </span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="12" sm="7" md="8">
                                    <ckeditor v-model="option_02" :config="editorConfig"></ckeditor>
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <v-row>
                                        <v-col cols="12">
                                            <v-file-input v-model="optfile2" accept="image/jpeg, image/jpg" prepend-icon="mdi-attachment" label="Choose File" id="file1" show-size name="doc"></v-file-input>
                                        </v-col>
                                        <v-col cols="12">
                                            <input type="radio" class="radiospace" id="b" value="b" v-model="iscorrect_02" @change="radio2(iscorrect_02)" />
                                            <label for="b">Correct Answer</label>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>

                    <v-btn style="display" class="button btn-submit-align" id="option3" :loading="loader" @click="enableOption3()">Add Option</v-btn>
                </div>
                <div id="C" style="display: none;">
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="card-border">
                            <!-- <v-alert class="alert" v-if="this.flag4==true" dismissible outlined type="error">
                                Image size should be less than 200KB!
                            </v-alert> -->
                            <v-row>
                                <v-col cols="12" sm="1" md="1">
                                    <v-tooltip bottom color="primary">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" class="mx-2 button-cancel" fab small @click="close3()"><v-icon dark>mdi-close</v-icon></v-btn>
                                        </template>
                                        <span>
                                            Remove
                                        </span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="12" sm="7" md="8">
                                    <ckeditor v-model="option_03" :config="editorConfig"></ckeditor>
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <v-row>
                                        <v-col cols="12">
                                            <v-file-input v-model="optfile3" accept="image/jpeg, image/jpg" prepend-icon="mdi-attachment" label="Choose File" id="file1" show-size name="doc"></v-file-input>
                                        </v-col>
                                        <v-col cols="12">
                                            <input type="radio" class="radiospace" id="c" value="c" v-model="iscorrect_03" @change="radio3(iscorrect_03)" />
                                            <label for="c">Correct Answer</label>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>

                    <v-btn style="display" class="button btn-submit-align" id="option4" :loading="loader" @click="enableOption4()">Add Option</v-btn>
                </div>
                <div id="D" style="display: none;">
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="card-border">
                            <!-- <v-alert class="alert" v-if="this.flag5==true" dismissible outlined type="error">
                                Image size should be less than 200KB!
                            </v-alert> -->
                            <v-row>
                                <v-col cols="12" sm="1" md="1">
                                    <v-tooltip bottom color="primary">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" class="mx-2 button-cancel" fab small @click="close4()"><v-icon dark>mdi-close</v-icon></v-btn>
                                        </template>
                                        <span>
                                            Remove
                                        </span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="12" sm="7" md="8">
                                    <ckeditor v-model="option_04" :config="editorConfig"></ckeditor>
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <v-row>
                                        <v-col cols="12">
                                            <v-file-input v-model="optfile4" accept="image/jpeg, image/jpg" prepend-icon="mdi-attachment" label="Choose File" id="file1" show-size name="doc"></v-file-input>
                                        </v-col>
                                        <v-col cols="12">
                                            <input type="radio" class="radiospace" id="d" value="d" v-model="iscorrect_04" @change="radio4(iscorrect_04)" />
                                            <label for="d">Correct Answer</label>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>

                    <v-btn style="display" class="button btn-submit-align" id="option5" :loading="loader" @click="enableOption5()">Add Option</v-btn>
                </div>
                <div id="E" style="display: none;">
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="card-border">
                            <!-- <v-alert class="alert" v-if="this.flag6==true" dismissible outlined type="error">
                                Image size should be less than 200KB!
                            </v-alert> -->
                            <v-row>
                                <v-col cols="12" sm="1" md="1">
                                    <v-tooltip bottom color="primary">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" class="mx-2 button-cancel" fab small @click="close5()"><v-icon dark>mdi-close</v-icon></v-btn>
                                        </template>
                                        <span>
                                            Remove
                                        </span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="12" sm="7" md="8">
                                    <ckeditor v-model="option_05" :config="editorConfig"></ckeditor>
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <v-row>
                                        <v-col cols="12">
                                            <v-file-input v-model="optfile5" accept="image/jpeg, image/jpg" prepend-icon="mdi-attachment" label="Choose File" id="file1" show-size name="doc"></v-file-input>
                                        </v-col>
                                        <v-col cols="12">
                                            <input type="radio" class="radiospace" id="e" value="e" v-model="iscorrect_05" @change="radio5(iscorrect_05)" />
                                            <label for="e">Correct Answer</label>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </div>
            </v-col>
            <v-card-actions>
                <v-btn style="display" class="button btn-submit-align" id="option" :loading="loader" @click="enableOption1()">Add Option</v-btn>
                <v-row justify="center">
                    <v-btn class="button" @click="saveEditedQuestion(my_opt_list)">Save</v-btn>
                </v-row>
            </v-card-actions>
        </v-card>

        <div class="text-center">
            <v-dialog v-model="dialog_upload" hide-overlay persistent width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Please Wait
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
        <v-dialog v-model="dialog_zooimg" persistent max-width="800px">
            <v-card>
                <v-card-title>
                    <span class="headline">Image Pre-View</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <img class="rounded w-100 d-block imgs-preview" :src="img_url" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="button-cancel" text @click="dialog_zooimg = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_delete" persistent max-width="400px">
            <v-card>
                <v-container>
                    <input type="hidden" v-model="deleteItem.delete_id" />
                    <input type="hidden" v-model="deleteItem.type" />
                    <h3><strong>Are you sure you want Delete this???</strong></h3>
                    <center>
                        <v-btn class="button-cancel span-mr" text @click="dialog_delete = false">No</v-btn>
                        <v-btn class="button" text @click="deleteFile()">Yes</v-btn>
                    </center>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import axios from "axios";
    import { VueMathjax } from "vue-mathjax";
    import MathLive from "mathlive";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import { mdiAccount, mdiPencil, mdiShareVariant, mdiDelete } from "@mdi/js";
    export default {
        components: {
            "vue-mathjax": VueMathjax,
        },
        data: () => ({
            editorConfig: {
                height: "100px",
                // The configuration of the editor.
                extraPlugins: "mathjax",
                //mathJaxLib: 'http://cdn.mathjax.org/mathjax/2.6-latest/MathJax.js?config=TeX-AMS_HTML',
                mathJaxLib: "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS_HTML",
            },
            snackbar_msg: "",
            dialog_zooimg: false,
            img_url: null,
            snackbar: false,
            loader: false,
            flag: null,
            flag1: null,
            flag2: null,
            flag3: null,
            flag4: null,
            flag5: null,
            flag6: null,
            color: "",
            marks_list: [
                { id: 1, marks: "1" },
                { id: 2, marks: "2" },
                { id: 3, marks: "3" },
                { id: 4, marks: "4" },
                { id: 5, marks: "5" },
                { id: 6, marks: "6" },
                { id: 7, marks: "7" },
                { id: 8, marks: "8" },
                { id: 9, marks: "9" },
                { id: 10, marks: "10" },
            ],
            ext_flag: false,
            ext_flag1: false,
            ext_flag2: false,
            ext_flag3: false,
            ext_flag4: false,
            ext_flag5: false,
            difficulty_info_list: null,
            unit_info_list: null,
            checkedNames: "",
            isChecked: false,
            picked: "one",
            loader: false,
            valid: false,
            question_info: null,
            questionid: null,
            quiz_type_list: null,
            dialog_upload: false,
            current_course: null,
            c_id: null,
            course_name: null,
            course_code: null,
            img_url: null,
            dialog_zooimg: false,
            questiontype: null,
            id: null,
            quiztype: null,
            weightage_edit: "",
            difficultylevel: "",
            unit: "",
            question_edit: "",
            file_edit: null,
            opt_file_edit: "",
            isapprove_edit: true,
            que_file: "",
            que_id: "",
            my_opt_list: "",
            optfile1: null,
            optfile2: null,
            optfile3: null,
            optfile4: null,
            optfile5: null,
            option_01: null,
            option_02: null,
            option_03: null,
            option_04: null,
            option_05: null,
            iscorrect_01: null,
            iscorrect_02: null,
            iscorrect_03: null,
            iscorrect_04: null,
            iscorrect_05: null,
            dialog_delete: false,
            deleteItem: {
                delete_id: "",
                type: "",
            },
            editedItem: {
                que_id: null,
                option_value: null,
                op_file: null,
                iscorrect: null,
                option_name: null,
                isapprove: null,
                weightage: null,
                question: null,
                que_file: null,
                file_link: null,
                difficultylevel: null,
            },
        }),
        mounted() {
            this.onload();
        },
        methods: {
            back() {
                this.$router.push({ name: "inst-question-view" });
            },
            enableOption1() {
                var opt = document.getElementById("A");
                var optbtn = document.getElementById("option");
                opt.style.display = "block";
                optbtn.style.display = "none";
            },
            enableOption2() {
                var opt = document.getElementById("B");
                var optbtn2 = document.getElementById("option2");
                opt.style.display = "block";
                optbtn2.style.display = "none";
            },
            enableOption3() {
                var opt = document.getElementById("C");
                var optbtn2 = document.getElementById("option3");
                opt.style.display = "block";
                optbtn2.style.display = "none";
            },
            enableOption4() {
                var opt = document.getElementById("D");
                var optbtn2 = document.getElementById("option4");
                opt.style.display = "block";
                optbtn2.style.display = "none";
            },
            enableOption5() {
                var opt = document.getElementById("E");
                var optbtn2 = document.getElementById("option5");
                opt.style.display = "block";
                optbtn2.style.display = "none";
            },
            radio(index) {
               // alert(index)
                for (let i = 0; i < this.my_opt_list.length; i++) {
                    if (i == index) {
                        if (this.my_opt_list[i].opt_iscorrect == false) {
                           // alert("in if....")
                            this.my_opt_list[i].opt_iscorrect = true;
                           // alert(this.my_opt_list[i].opt_iscorrect)
                        }
                    } else {
                        // alert("in else....")
                        this.my_opt_list[i].opt_iscorrect = false;
                    }
                }
            },
            radio1(iscorrect_01) {
                //alert (iscorrect_01)
                if (iscorrect_01 == "a") {
                    for (let i = 0; i < this.my_opt_list.length; i++) {
                        this.my_opt_list[i].opt_iscorrect = false;
                    }
                    this.iscorrect_01 = true;
                }
            },
            radio2(iscorrect_02) {
                // alert (iscorrect_02)
                if (iscorrect_02 == "b") {
                    for (let i = 0; i < this.my_opt_list.length; i++) {
                        this.my_opt_list[i].opt_iscorrect = false;
                    }
                    this.iscorrect_01 = false;
                    this.iscorrect_02 = true;
                }
            },
            radio3(iscorrect_03) {
                //  alert (iscorrect_03)
                if (iscorrect_03 == "c") {
                    for (let i = 0; i < this.my_opt_list.length; i++) {
                        this.my_opt_list[i].opt_iscorrect = false;
                    }
                    this.iscorrect_01 = false;
                    this.iscorrect_02 = false;
                    this.iscorrect_03 = true;
                }
            },
            radio4(iscorrect_04) {
                // alert (iscorrect_04)
                if (iscorrect_04 == "d") {
                    for (let i = 0; i < this.my_opt_list.length; i++) {
                        this.my_opt_list[i].opt_iscorrect = false;
                    }
                    this.iscorrect_01 = false;
                    this.iscorrect_02 = false;
                    this.iscorrect_03 = false;
                    this.iscorrect_04 = true;
                }
            },
            radio5(iscorrect_05) {
                //  alert (iscorrect_05)
                if (iscorrect_05 == "e") {
                    for (let i = 0; i < this.my_opt_list.length; i++) {
                        this.my_opt_list[i].opt_iscorrect = false;
                    }
                    this.iscorrect_01 = false;
                    this.iscorrect_02 = false;
                    this.iscorrect_03 = false;
                    this.iscorrect_04 = false;
                    this.iscorrect_05 = true;
                }
            },
            validateFile() {
                // alert("validateFile");
                // let file = this.file_edit;
                //     if (file.size > 200000) {
                //         this.file_edit = "";
                //         this.flag = true;
                //         return;
                //     }

                this.ext_flag = false;
                if (this.file_edit) {
                    let file = this.file_edit;
                    let file_name = this.file_edit.name;
                    // alert("file_name"+file_name)
                    let ext = file_name.split(".").pop();
                    // alert("ext: "+ext)
                     if (ext == "jpeg" || ext == "jpg" || ext == "JPEG" || ext == "JPG") {
                        //alert("ext 2 : "+ext)
                        if (file.size > 200000) {
                            // alert("file.size: "+file.size)
                            // alert("854 inside if")
                            this.file_edit = "";
                            this.flag = true;
                            this.ext_flag = true;
                            return false;
                        } else {
                            this.ext_flag == false;
                            // alert("859 inside else")
                            return true;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            },
            validateFileTypeOpt01() {
                // alert("validateFileTypeOpt01")
                // let file = this.optfile1;
                // if (file.size > 200000) {
                //     this.optfile1 = "";
                //     this.flag2 = true;
                //     return;
                // }
                this.ext_flag1 = false;
                if (this.optfile1) {
                    // alert("in if")
                    let file = this.optfile1;
                    //alert("Opt01 file : "+file)
                    let file_name = this.optfile1.name;
                    // alert("Opt01 file_name : "+file_name)
                    let ext = file_name.split(".").pop();
                     if (ext == "jpeg" || ext == "jpg" || ext == "JPEG" || ext == "JPG") {
                        // console.log("Opt01 ext 2 : "+ext)
                        if (file.size > 200000) {
                            // alert("Opt01 file.size: " + file.size);
                            // alert("Opt01 889 inside if");
                            this.optfile1 = "";
                            //this.flag=true
                            this.ext_flag1 = true;
                            return false;
                        } else {
                            this.ext_flag1 == false;
                            //  alert("Opt01 896 inside else");
                            return true;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            },
            validateFileTypeOpt02() {
                // let file = this.optfile2;
                // if (file.size > 200000) {
                //     this.optfile2 = "";
                //     this.flag3 = true;
                //     return;
                // }
                this.ext_flag2 = false;
                if (this.optfile2) {
                    let file = this.optfile2;
                    // alert("Opt02 file : "+file)
                    let file_name = this.optfile2.name;
                    //  alert("Opt01 file_name : "+file_name)
                    let ext = file_name.split(".").pop();
                     if (ext == "jpeg" || ext == "jpg" || ext == "JPEG" || ext == "JPG") {
                        // alert("Opt01 ext 2 : "+ext)
                        if (file.size > 200000) {
                            //  alert("Opt01 file.size: "+file.size)
                            //  alert("Opt01 889 inside if")
                            this.optfile2 = "";
                            //this.flag=true
                            this.ext_flag2 = true;
                            return false;
                        } else {
                            this.ext_flag2 == false;
                            //  alert("Opt01 896 inside else")
                            return true;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            },
            validateFileTypeOpt03() {
                // let file = this.optfile3;
                // if (file.size > 200000) {
                //     this.optfile3 = "";
                //     this.flag4 = true;
                //     return;
                // }
                this.ext_flag3 = false;
                if (this.optfile3) {
                    let file = this.optfile3;
                    // alert("Opt03 file : "+file)
                    let file_name = this.optfile3.name;
                    // alert("Opt03 file_name : "+file_name)
                    let ext = file_name.split(".").pop();
                    if (ext == "jpeg" || ext == "jpg" || ext == "JPEG" || ext == "JPG") {
                        // alert("Opt03 ext 3 : "+ext)
                        if (file.size > 200000) {
                            //  alert("Opt01 file.size: "+file.size)
                            //  alert("Opt01 889 inside if")
                            this.optfile3 = "";
                            //this.flag=true
                            this.ext_flag3 = true;
                            return false;
                        } else {
                            this.ext_flag3 == false;
                            //  alert("Opt01 896 inside else")
                            return true;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            },
            validateFileTypeOpt04() {
                // let file = this.optfile4;
                // if (file.size > 200000) {
                //     this.optfile4 = "";
                //     this.flag5 = true;
                //     return;
                // }
                this.ext_flag4 = false;
                if (this.optfile4) {
                    let file = this.optfile4;
                    //alert("Opt04 file : "+file)
                    let file_name = this.optfile4.name;
                    // alert("Opt03 file_name : "+file_name)
                    let ext = file_name.split(".").pop();
                     if (ext == "jpeg" || ext == "jpg" || ext == "JPEG" || ext == "JPG") {
                        //  alert("Opt03 ext 3 : "+ext)
                        if (file.size > 200000) {
                            //     alert("Opt01 file.size: "+file.size)
                            //    alert("Opt01 889 inside if")
                            this.optfile4 = "";
                            //this.flag=true
                            this.ext_flag4 = true;
                            return false;
                        } else {
                            this.ext_flag4 == false;
                            //  alert("Opt01 896 inside else")
                            return true;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            },
            validateFileTypeOpt05() {
                // let file = this.optfile5;
                // if (file.size > 200000) {
                //     this.optfile5 = "";
                //     this.flag6 = true;
                //     return;
                // }
                this.ext_flag5 = false;
                if (this.optfile5) {
                    let file = this.optfile5;
                    //  alert("Opt05 file : "+file)
                    let file_name = this.optfile5.name;
                    // alert("Opt03 file_name : "+file_name)
                    let ext = file_name.split(".").pop();
                     if (ext == "jpeg" || ext == "jpg" || ext == "JPEG" || ext == "JPG") {
                        //   alert("Opt03 ext 3 : "+ext)
                        if (file.size > 200000) {
                            //   alert("Opt01 file.size: "+file.size)
                            //   alert("Opt01 889 inside if")
                            this.optfile5 = "";
                            //this.flag=true
                            this.ext_flag5 = true;
                            return false;
                        } else {
                            this.ext_flag5 == false;
                            // alert("Opt01 896 inside else")
                            return true;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            },
            validateFile1() {
                for (let i = 0; i < this.my_opt_list.length; i++) {
                    let file = this.my_opt_list[i].filename;
                    if (file.size > 200000) {
                        this.my_opt_list[i].filename = "";
                        this.flag1 = true;
                        return;
                    }
                }
            },
            close() {
                this.$router.push("/create-question-bank");
            },
            close1() {
                var opt = document.getElementById("A");
                opt.style.display = "none";
                this.option_01 = null
                this.iscorrect_01 = null
                this.optfile1 = null
                var optbtn = document.getElementById("option");
                optbtn.style.display = "block";
            },
            close2() {
                var opt = document.getElementById("B");
                opt.style.display = "none";
                this.option_02 = null
                this.iscorrect_02 = null
                this.optfile2 = null
                var optbtn = document.getElementById("option2");
                optbtn.style.display = "block";
            },
            close3() {
                var opt = document.getElementById("C");
                opt.style.display = "none";
                this.option_03 = null
                this.iscorrect_03 = null
                this.optfile3 = null
                var optbtn = document.getElementById("option3");
                optbtn.style.display = "block";
            },
            close4() {
                var opt = document.getElementById("D");
                opt.style.display = "none";
                this.option_04 = null
                this.iscorrect_04 = null
                this.optfile4 = null
                var optbtn = document.getElementById("option4");
                optbtn.style.display = "block";
            },
            close5() {
                var opt = document.getElementById("E");
                opt.style.display = "none";
                this.option_05 = null
                this.iscorrect_05 = null
                this.optfile5 = null
                var optbtn = document.getElementById("option5");
                optbtn.style.display = "block";
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            zooimg(url_img) {
                //alert("zooimg"+url_img)
                this.img_url = url_img;
                this.dialog_zooimg = true;
            },
            deletedialog(optionid, type) {
                // alert(optionid)
                // alert(type)
                this.dialog_delete = true;
                this.deleteItem.delete_id = optionid;
                this.deleteItem.type = type;
            },
            deleteFile() {
                // alert("delete file"+optionid);
                const data = {
                    crs_id: this.$store.getters.courseid,
                    qtypeid: this.$store.getters.qbankquestype,
                    questypeid: this.$store.getters.questype,
                    optionid: this.deleteItem.delete_id,
                    type: this.deleteItem.type,
                };
                axios
                    .post("/Qbank/deleteQuestionFile", data)
                    .then((res) => {
                        if (res.data.status.code == "SUCCESS") {
                            this.showSnackbar("#4CAF50", res.data.status.message);
                            this.dialog_delete = false;
                            this.onload();
                        } else {
                            this.showSnackbar("#b71c1c", "Cant delete, may be some reference present!!!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            saveEditedQuestion(opt) {
                if (this.validateFile()) {
                    // alert("in if");
                    if (this.validateFileTypeOpt01()) {
                        if (this.validateFileTypeOpt02()) {
                            if (this.validateFileTypeOpt03()) {
                                if (this.validateFileTypeOpt04()) {
                                    if (this.validateFileTypeOpt05()) {
                                        // alert("in if");
                                        this.dialog_upload = true;
                                        let formData = new FormData();
                                        let option = {};
                                        for (let i = 0; i < opt.length; i++) {
                                            option["id" + (i + 1)] = opt[i].opt_id;
                                            formData.append("opt_id" + (i + 1), opt[i].opt_id);
                                            formData.append("opt_value" + (i + 1), opt[i].opt_txt);
                                            formData.append("opt_iscorrect" + (i + 1), opt[i].opt_iscorrect);
                                            formData.append("opt_file" + (i + 1), opt[i].filename);
                                        }
                                        formData.append("question_id", this.que_id);
                                        formData.append("question_text", this.question_edit);
                                        formData.append("que_file", this.file_edit);
                                        formData.append("weightage", this.weightage_edit);
                                        formData.append("unit", this.unit.id);
                                        formData.append("difficultylevel", this.difficultylevel.id);

                                        formData.append("isapprove", this.isapprove_edit);
                                        //opt01
                                        formData.append("option_01", this.option_01);
                                        formData.append("iscorrect_01", this.iscorrect_01);
                                        formData.append("optfile1", this.optfile1);
                                        //opt 02
                                        formData.append("option_02", this.option_02);
                                        formData.append("iscorrect_02", this.iscorrect_02);
                                        formData.append("optfile2", this.optfile2);
                                        //opt 03
                                        formData.append("option_03", this.option_03);
                                        formData.append("iscorrect_03", this.iscorrect_03);
                                        formData.append("optfile3", this.optfile3);
                                        //opt 04
                                        formData.append("option_04", this.option_04);
                                        formData.append("iscorrect_04", this.iscorrect_04);
                                        formData.append("optfile4", this.optfile4);
                                        //opt 05
                                        formData.append("option_05", this.option_05);
                                        formData.append("iscorrect_05", this.iscorrect_05);
                                        formData.append("optfile5", this.optfile5);
                                        axios
                                            .post("/Qbank/editQuestionBank", formData)
                                            .then((res) => {
                                                if (res.data.flag == "YES") {
                                                    this.showSnackbar("#4CAF50", "Updated Successfully !!");
                                                    this.dialog_upload = false;
                                                }
                                            })
                                            .catch((error) => {
                                                this.showSnackbar("#b71c1c", "Something went wrong!!!");
                                                this.dialog_upload = false;
                                            })
                                            .finally(() => {
                                                this.ext_flag = false;
                                                this.ext_flag1 = false;
                                                this.ext_flag2 = false;
                                                this.ext_flag3 = false;
                                                this.ext_flag4 = false;
                                                this.ext_flag5 = false;
                                                this.$router.push("/inst-question-view");
                                            });
                                    } else {
                                        if (this.ext_flag5 == true) {
                                            this.showSnackbar("#b71c1c", "Option 5 Image file should not exceed 200kb size!"); // show snackbar on error
                                        } else {
                                            this.ext_flag5 == false;
                                            this.showSnackbar("#b71c1c", " For Option 5, please upload only image file! (.JPEG / .JPG)"); // show snackbar on error
                                        }
                                    }
                                } else {
                                    if (this.ext_flag4 == true) {
                                        this.showSnackbar("#b71c1c", "Option 4 Image file should not exceed 200kb size!"); // show snackbar on error
                                    } else {
                                        this.ext_flag4 == false;
                                        this.showSnackbar("#b71c1c", " For Option 4, please upload only image file! (.JPEG / .JPG)"); // show snackbar on error
                                    }
                                }
                            } else {
                                if (this.ext_flag3 == true) {
                                    this.showSnackbar("#b71c1c", "Option 3 Image file should not exceed 200kb size!"); // show snackbar on error
                                } else {
                                    this.ext_flag3 == false;
                                    this.showSnackbar("#b71c1c", " For Option 3, please upload only image file! (.JPEG / .JPG)"); // show snackbar on error
                                }
                            }
                        } else {
                            if (this.ext_flag2 == true) {
                                this.showSnackbar("#b71c1c", "Option 2 Image file should not exceed 200kb size!"); // show snackbar on error
                            } else {
                                this.ext_flag2 == false;
                                this.showSnackbar("#b71c1c", " For Option 2, please upload only image file! (.JPEG / .JPG)"); // show snackbar on error
                            }
                        }
                    } else {
                        if (this.ext_flag1 == true) {
                            this.showSnackbar("#b71c1c", "Option 1 Image file should not exceed 200kb size!"); // show snackbar on error
                        } else {
                            this.ext_flag1 == false;
                            this.showSnackbar("#b71c1c", " For Option 1, please upload only image file! (.JPEG / .JPG)"); // show snackbar on error
                        }
                    }
                } else {
                    if (this.ext_flag == true) {
                        this.showSnackbar("#b71c1c", "Question Image file should not exceed 200kb size!"); // show snackbar on error
                    } else {
                        this.ext_flag == false;
                        this.showSnackbar("#b71c1c", "For Question please upload only image file! (.JPEG / .JPG)"); // show snackbar on error
                    }
                }
            },
            onload() {
                this.questionid = this.$route.params.que_id;
                this.courseinfo = this.$route.params.courseinfo;
                const data = {
                    questionid: this.questionid,
                    courseinfo: this.courseinfo,
                };
                axios
                    .post("/Qbank/editQbank", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.course_code = res.data.course_code;
                            this.course_name = res.data.course_name;
                            this.question_edit = res.data.question;
                            this.weightage_edit = res.data.weightage;

                            this.unit_info_list = res.data.unitno;
                            this.difficulty_info_list = res.data.difficultylevelno;

                            // this.unit_info_list = res.data.unit_info_list;
                            // this.difficulty_info_list = res.data.difficulty_info_list;

                            this.difficultylevel = res.data.difficultylevel;
                            this.unit = res.data.unit;

                            this.isapprove_edit = res.data.isapprove;
                            this.que_file_link = res.data.que_file_link;
                            this.que_file = res.data.que_file;
                            this.questiontype = res.data.questiontype;
                            this.que_id = res.data.que_id;
                            this.my_opt_list = res.data.my_opt_list;
                            for (let i = 0; i < this.my_opt_list.length; i++) {
                                this.my_opt_list[i].filename;
                                this.my_opt_list[i].radio = "radio" + (i + 1);
                            }
                            this.ext_flag = false;
                            this.ext_flag1 = false;
                            this.ext_flag2 = false;
                            this.ext_flag3 = false;
                            this.ext_flag4 = false;
                            this.ext_flag5 = false;
                            //  this.showSnackbar("#4CAF50", "Load Successfully !!");
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch(function () {
                        console.log("FAILURE!!");
                    })
                    .finally(() => {
                        this.output_load = false;
                    });
            },
        },
    };
</script>
<style scoped>
    .row {
        margin: 1rem !important;
        padding: 0%;
    }

    .col-mr {
        margin: 0% !important;
        padding: 0%;
    }

    .toolbar {
        background-color: #ffb500 !important;
        color: #ffffff !important;
    }

    .btn-submit:hover {
        background-color: #ffb500 !important;
        color: #ffffff !important;
    }

    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }

    .span-mr {
        margin: 1rem !important;
        padding: 0px;
    }

    .card-border {
        border: 2px solid hsla(190, 99%, 30%, 1) !important;
        border-radius: 10px;
        padding: 5px;
        margin: 1rem !important;
        width: auto;
    }

    .imgs {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: 150px;
        cursor: zoom-in;
    }
    .box {
        background-color: #add8e630;
        margin: 8px !important;
        padding: 8px;
        color: hsla(190, 99%, 30%, 1) !important;
    }
    .imgs-preview {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: auto;
    }

    .msg {
        color: red;
    }

    .card {
        background: darkblue;
        color: white;
    }

    .btn-submit:hover {
        background-color: #ffb500 !important;
        color: #ffffff !important;
    }

    .slide {
        color: red;
        font-weight: bold;
        margin-left: 10px;
    }

    .name {
        color: #ffb500;
        font-weight: bold;
        letter-spacing: 1px;
    }

    v-simple-table {
        border-collapse: collapse;
        border-spacing: 0;
        width: auto;
        border: 1px solid #ddd;
    }

    th {
        color: white;
        font-weight: bold;
    }

    td,
    th {
        padding: 6px;
        border: 1px solid #ccc;
        text-align: left;
    }

    v-row {
        padding: 0px;
    }

    v-col {
        padding: 0px;
        margin: 0px;
    }

    span {
        padding: 0px;
        margin: 0px;
    }

    v-chip {
        width: auto;
    }

    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    .btn-submit-align {
        float: left;
        margin: 1rem !important;
    }
</style>
